var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value-unit"},[_c('div',{staticClass:"value-unit__value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"value-unit__unit"},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }